import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'inputError',
  standalone:true,
})
export class InputErrorPipe implements PipeTransform {
constructor(public translate: TranslateService){

}
 transform(value: any): string {
  
        let rvalue: string = '';
        if (value !== null) {
            if (value['invalid'] == true) {
                rvalue = 'error.invalid';
            }
            if (value['exists'] == true) {
                rvalue = 'error.exists';
            }
            if (value['required'] == true) {
                rvalue = 'error.required';
            }  
            if (value['pattern'] !=null) {
                rvalue = '';
                let requiredPattern: string = "";
                this.translate.get("error.pattern.requiredPattern").subscribe((data: any) => {
                    requiredPattern = data;
                });
                let actualValue: string = "";
                this.translate.get("error.pattern.actualValue").subscribe((data: any) => {
                    actualValue = data;
                });
                rvalue=requiredPattern+': '+value['pattern']['requiredPattern']+ '   ' +actualValue+': '+value['pattern']['actualValue'];
                
            }
            if (value['minlength'] !=null) {
                rvalue = '';
                let requiredLength: string = "";
                this.translate.get("error.minlength.requiredLength").subscribe((data: any) => {
                    requiredLength = data;
                });
                let actualLength: string = "";
                this.translate.get("error.minlength.actualLength").subscribe((data: any) => {
                    actualLength = data;
                });
                rvalue=requiredLength+': '+value['minlength']['requiredLength']+ '   ' +actualLength+': '+value['minlength']['actualLength'];
               
            }
            if (value['maxlength'] !=null) {
                rvalue = '';
                let requiredLength: string = "";
                this.translate.get("error.maxlength.requiredLength").subscribe((data: any) => {
                    requiredLength = data;
                });
                let actualLength: string = "";
                this.translate.get("error.maxlength.actualLength").subscribe((data: any) => {
                    actualLength = data;
                });
                rvalue=requiredLength+': '+value['maxlength']['requiredLength']+ '   ' +actualLength+': '+value['maxlength']['actualLength'];
               
            }

            if (value['max'] !=null) {
                rvalue = '';
               
                let maxvalue: string = "";
                this.translate.get("error.max.max").subscribe((data: any) => {
                    maxvalue = data;
                });
                let actualvalue: string = "";
                this.translate.get("error.max.actual").subscribe((data: any) => {
                    actualvalue = data;
                });
                rvalue=  maxvalue +' ' +value['max'].max+ ' ;  ' + actualvalue+': '+value['max'].actual;
               
            }
            if (value['min'] !=null) {
                rvalue = '';
               
                let maxvalue: string = "";
                this.translate.get("error.min.min").subscribe((data: any) => {
                    maxvalue = data;
                });
                let actualvalue: string = "";
                this.translate.get("error.min.actual").subscribe((data: any) => {
                    actualvalue = data;
                });
                rvalue=  maxvalue +' ' +value['min'].min+ ' ;  ' + actualvalue+': '+value['min'].actual;
               
            }
            if (value['email'] !=null) {
                rvalue = '';
                
                this.translate.get("listheader.enterprise.emailError").subscribe((data: any) => {
                    rvalue = data;
                });
               
               
            }
        }
        return rvalue;
    }
   /*  transform(value: any, ...args: any[]): string {
        let entered:boolean=false;
        let rvalue: string='';
        if(value){
          Object.values(value).forEach((message) => {
            if(typeof message !== 'undefined'){
              if (entered) {
                rvalue += '\n ';
              }
              entered=true;
              rvalue += message;
            }
          });
        }else{
          rvalue='';
        }
        return rvalue;
      } */
}